export default __webpack_public_path__ + "static/media/sch1.bd18714d.jpg";